import type { ButtonHTMLAttributes } from 'react';
import { cx } from '@parrot/utils';
import styles from './AuthLink.module.css';

/**
 * Reads as a link, behaves as a button. Never an <a>: navigation belongs to the host
 * app, so there is no href to give it, and an anchor without one is not operable.
 */
export const AuthLink = ({
  className,
  ...buttonProps
}: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button type={'button'} className={cx(styles.base, className)} {...buttonProps} />
);
